import CardCarousel from './CardCarousel'
import Card from './Card'

export default {
  card_carousel: CardCarousel,
  card_carousel_card: Card,
}
